module.exports = __webpack_public_path__ + "static/blog_grid_8-79c71cd8952e667f44b2e3cc7412f02d.jpg";